import styled from "styled-components";

export const DragComponent = styled.div`
  position: relative;
  z-index: 1000;
`;

export const DragIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 14px;
  height: 100%;
  cursor: pointer;
  cursor: grab;
`;